// extracted by mini-css-extract-plugin
export var menuIcon = "_qy-0";
export var menuIconInline = "_qy-1";